import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';

import { sprintf } from 'sprintf-js';

import ui from '@cob/ui-genesis/cob.ui.js';

var DeleteInstance = function(core) {

    var _loadingKey = core.getLoadingKey(),
        _indexedInstanceM;

    var _deleteInstance = function() {
        _indexedInstanceM.deleteSelf({
            success: function() {
                core.hideLoading(_loadingKey, 'delete instance');
            },
            error: function(message, reasons) {
                var msg = message;

                if (reasons) {
                    msg += ":<br />- " + reasons.join("<br />- ");
                }

                // Make the notification sticky
                ui.notification.showError(msg, true);
                core.hideLoading(_loadingKey, 'error deleting instance');
            }
        });
    };

    var _confirmDelete = function(onConfirmCb) {
        var instanceDescription = _indexedInstanceM.getDescription(),
            message = sprintf(core.translateString("recordm.instances", "msgs.delete-msg"), instanceDescription),
            warningMessage;

        if (_indexedInstanceM.data.references) {
            if (_indexedInstanceM.data.references === 1) {
                warningMessage = sprintf(
                    core.translateString("recordm.instances", "msgs.total-referencing.single"),
                    _indexedInstanceM.data.references
                )
            } else {
                warningMessage = sprintf(
                    core.translateString("recordm.instances", "msgs.total-referencing.plural"),
                    _indexedInstanceM.data.references
                )
            }
        }

        ConfirmDialog(core, {
                message: message,
                warningMessage: warningMessage,
                confirmBtnLabel: core.translateString("recordm.instances", "action.delete"),
                confirmBtnClass: "btn-danger"
            },
            {
                requestConfirmed: onConfirmCb
            }
        );
    };

    var _execute = function(indexedInstanceM) {
        _indexedInstanceM = indexedInstanceM;

        core.showLoading(_loadingKey, 'updating total references');
        _indexedInstanceM.updateTotalReferencing(
            function() {
                core.hideLoading(_loadingKey, 'updating total references done');
                _confirmDelete(_deleteInstance)
            },
            function() {
                core.hideLoading(_loadingKey, 'error updating total references');
            }
        )
    };

    return {
        execute: _execute
    }
};

export default DeleteInstance;
